import CTAS from './view';

export default CTAS
export { CTAS as Base }
